import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SwitchInput } from '../../SwitchInput';
import { getTranslation } from '../../../utils/translations';

import { navSelector } from '../../../../../sites/aflm/store/js/modules/competition-nav/selectors';
import { bettingOddsSelector } from '../../../../../sites/aflm/store/js/modules/competition-nav/selectors';
import { UPDATE_BETTING_ODDS } from '../../../../../sites/aflm/store/js/modules/competition-nav/actions';
import { useGetCompSeasonQuery } from '../../../../../sites/aflm/store/js/modules/api/afl-api';
import { useGetBettingOddsQuery } from '../../../../../sites/aflm/store/js/modules/api/cfs-api';
import { useIsBettingSuppressed } from '../../../utils/is-betting-suppressed';

export const BettingOddsNavItem = () => {
    const dispatch = useDispatch();

    const bettingOdds = useSelector(bettingOddsSelector);
    const nav = useSelector(navSelector);

    // check if data exists for compseason and current round

    const { data: compSeasonData = [] } = useGetCompSeasonQuery(
        { id: nav.season.id },
        {
            skip: !nav.season.id
        }
    );

    const competitionId = compSeasonData[0]?.competition?.providerId;

    const { data: bettingData } = useGetBettingOddsQuery();

    let activeRounds = [];
    activeRounds = [
        ...new Set(
            bettingData?.competition?.books?.map((item) => parseInt(item.round))
        )
    ];

    if (useIsBettingSuppressed(bettingData, competitionId, activeRounds)) {
        return <></>;
    }

    return (
        <div className={`competition-nav__betting-odds-toggle`}>
            <img
                className="icon"
                src={`/resources/${window.RESOURCES_VERSION}/i/elements/sports-bet-mini.png`}
            />

            <SwitchInput
                id="brownlow-tracker-betting-odds-toggle"
                label={getTranslation('label.brownlow.bettingOdds.toggle')}
                isChecked={bettingOdds.isActive}
                onChange={(isActive) =>
                    dispatch(UPDATE_BETTING_ODDS.request({ isActive }))
                }
            />
        </div>
    );
};
